import C from 'crypto-js';
import { notifications } from '@mantine/notifications';
import { SessionStore } from '../utils/SessionStore';
import { getPublicAccessToken, isProtectedRoute, PUBLIC_ACCESS_FORM_FIELD } from '../utils/publicAccess';

const KEY = C.MD5("q3t6w9z$C&F)J@McQfTjWnZr4u7x!A%D*G-KaPdRgUkXp2s5v8y/B?E(H+MbQeThVkYp3s5v8y/B?E(H+MbQeThWmZq4t7w9");
const IV = C.MD5("mZq4t7w9z$C&F)J@NcRfUjXn2r5u8x/A%D*G-KaPdSgVkYp3s6v9y$B&E(H+MbQe6v9y$B&E(H+MbQeThWmZq4t7w!z%C*F-");

export function encrypt(value) {
  return C.AES.encrypt(value, KEY, { iv: IV }).ciphertext.toString(C.enc.Base64);
}


export function toDoWithForms(url, postData) {
  if (!isProtectedRoute(url)) {
    submitForm(url, postData, null);
    return;
  }
  getPublicAccessToken()
    .then((token) => submitForm(url, postData, token))
    .catch((error) => notifyApiError(error, 'Não foi possível verificar o acesso'));
}

function submitForm(url, postData, publicAccessToken) {
  var elemId = 'ApiSubmitter' + new Date().getMilliseconds();

  const form = document.createElement("form");
  form.id = 'form' + elemId;
  form.method = 'post';
  form.action = process.env.REACT_APP_API_URL + url;
  form.target = '_self:' + url;//'ifr' + url;
  form.enctype = "multipart/form-data";
  form.style.display = 'none';



  const inputFormParam = document.createElement('input');
  inputFormParam.id = 'formParam' + elemId;
  inputFormParam.name = "FormParams";
  inputFormParam.type = 'hidden';
  if (!!postData)
    inputFormParam.value = JSON.stringify(postData);

  form.appendChild(inputFormParam);

  const inputFormAuthorization = document.createElement('input');
  inputFormAuthorization.id = 'Authorization' + elemId;
  inputFormAuthorization.name = "Authorization";
  inputFormAuthorization.type = 'hidden';
  inputFormAuthorization.value = SessionStore.getSessionKey();

  form.appendChild(inputFormAuthorization);

  if (publicAccessToken) {
    const inputPublicAccess = document.createElement('input');
    inputPublicAccess.name = PUBLIC_ACCESS_FORM_FIELD;
    inputPublicAccess.type = 'hidden';
    inputPublicAccess.value = publicAccessToken;
    form.appendChild(inputPublicAccess);
  }

  document.body.appendChild(form);

  form.submit();


  setTimeout(function () {

    document.body.removeChild(form);

  }, 5 * 60 * 1000);
};

// The API answers business and configuration errors with 400 and a body
// shaped like ["message", detail].
function apiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (Array.isArray(data) && typeof data[0] === 'string' && data[0]) return data[0];
  if (typeof data === 'string' && data) return data;
  return fallback;
}

export function notifyApiError(error, title) {
  console.error(`[${title}]`, error);
  const message = apiErrorMessage(error, 'Tente novamente em instantes.');
  notifications.show({ color: 'red', title, message });
  return message;
}
